"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultProps = {
  className: '',
  label: null,
  feedback: null,
  description: null,
  errors: null
};
/**
 * Basic form input wrapper that adds a label, error text, and a help block.
 * Also has "feedback", which goes in italics in the upper right (chars remaining etc.)
 */

const FormGroup = props => {
  const {
    children,
    className = '',
    label,
    labelId,
    feedback,
    description,
    errors
  } = props;
  const [css, theme] = (0, _theme.useStyletron)();
  const errorElement = errors ? /*#__PURE__*/_react.default.createElement("div", {
    className: css({ ...theme.typography.bodyText4,
      color: theme.colors.negative400
    })
  }, errors) : null;
  const descriptionElement = description ? /*#__PURE__*/_react.default.createElement("div", {
    className: css({ ...theme.typography.bodyText5,
      color: theme.colors.grey50
    })
  }, description) : null;
  const above = label || feedback ? /*#__PURE__*/_react.default.createElement("div", {
    className: css({
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    })
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: css({ ...theme.typography.bodyText4,
      fontWeight: 700,
      marginBottom: '0.25rem',
      color: theme.colors.grey90,
      ...(theme.labelStyle || {})
    }),
    id: labelId
  }, label), feedback) : null;
  const below = errorElement || descriptionElement ? /*#__PURE__*/_react.default.createElement("div", {
    className: css({
      width: '100%',
      marginTop: '0.25rem'
    })
  }, errorElement, descriptionElement) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, above, children, below);
};

FormGroup.defaultProps = defaultProps;
var _default = FormGroup;
exports.default = _default;